import ScheduledDraftEventContent from './ScheduledDraftEventContent';

export default ScheduledDraftEventContent;
